import { render, staticRenderFns } from "./mbusiness.vue?vue&type=template&id=5b416e24&scoped=true&"
import script from "./mbusiness.vue?vue&type=script&lang=js&"
export * from "./mbusiness.vue?vue&type=script&lang=js&"
import style0 from "./mbusiness.vue?vue&type=style&index=0&id=5b416e24&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b416e24",
  null
  
)

export default component.exports